
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useWishlist } from '@/hooks/useWishlist';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

const WishlistSettingsTab = () => {
  const { wishlist, isLoading } = useWishlist();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Heart className="h-5 w-5" />
          My Wishlist
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i}>
                <Skeleton className="aspect-square w-full rounded-lg" />
                <Skeleton className="h-4 w-3/4 mt-2" />
                <Skeleton className="h-4 w-1/2 mt-1" />
              </div>
            ))}
          </div>
        )}
        {!isLoading && wishlist.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">
            <Heart className="h-10 w-10 mx-auto mb-4" />
            <p className="font-semibold">Your wishlist is empty</p>
            <p>Add items to your wishlist to see them here.</p>
          </div>
        )}
        {!isLoading && wishlist.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {wishlist.map((item) => (
              <Link to={`/product/${item.products.id}`} key={item.id} className="group">
                <div className="aspect-square w-full bg-gray-100 rounded-lg overflow-hidden relative">
                  <img
                    src={item.products.image_url}
                    alt={item.products.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
                <p className="text-sm font-medium truncate mt-2">{item.products.name}</p>
                <p className="text-sm text-muted-foreground">${Number(item.products.price).toFixed(2)}</p>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default WishlistSettingsTab;
